import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
          primary: '#0072bc',
          secondary: '#ed1c24',
          accent: '#0089e2',
          "accent-2": '#0089ff',
          error: '#f04d24',
          info: '#d0d2d4',
          success: '#20b740',
          warning: '#fa9f47',
          fondoCardForm:"#fff",
          fontColor:"#000",
          menuFontColor:"#fff",
          backgroundColor:"#b3d1e7"

      },
      dark: {
        primary: '#0072bc',
        secondary: '#ed1c24',
        accent: '#0089e2',
        "accent-2": '#0089ff',
        error: '#f04d24',
        info: '#d0d2d4',
        success: '#20b740',
        warning: '#fa9f47',
        fondoCardForm:"#fff",
        fontColor:"#fff"
      }
    }
  }
});
